import { NavLink, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  FiGrid,
  FiBox,
  FiFileText,
  FiList,
  FiUsers,
  FiCreditCard,
  FiBarChart2,
  FiSettings,
  FiHelpCircle,
  FiLogOut,
} from "react-icons/fi";

const items = [
  { to: "/", label: "Dashboard", icon: FiGrid },
  { to: "/containers", label: "Containers", icon: FiBox },
  { to: "/invoices", label: "Invoices", icon: FiFileText },
  { to: "/cost-price-list", label: "Cost Price List", icon: FiList },
  { to: "/vendors", label: "Vendors", icon: FiUsers },
  { to: "/payments", label: "Payments", icon: FiCreditCard },
  { to: "/reports", label: "Reports", icon: FiBarChart2 },
  { to: "/settings", label: "Settings", icon: FiSettings },
  { to: "/help", label: "Help", icon: FiHelpCircle },
];

export default function Sidebar() {
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    if (savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch {
        setUser(null);
      }
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setShowLogoutModal(false);
    navigate("/login");
  };

  const displayRole = user?.role ? String(user.role).replace(/_/g, " ") : "";

  return (
    <>
      <aside className="sticky top-0 flex h-screen w-72 shrink-0 flex-col border-r border-slate-200 bg-sidebar text-white shadow-soft transition-colors duration-300 dark:border-slate-800/80 dark:bg-slate-950">
        <div className="flex h-20 items-center gap-3 border-b border-white/10 bg-sidebar px-6 text-white transition-colors duration-300 dark:border-slate-800/80 dark:bg-slate-900">
          <div className="grid h-10 w-10 place-items-center rounded-md bg-emerald-500/90 font-bold text-white">
            X
          </div>
          <div className="text-2xl font-bold tracking-tight">Logistics</div>
        </div>

        <nav className="flex-1 overflow-y-auto px-4 py-5">
          <div className="space-y-1">
            {items.map(({ to, label, icon: Icon }) => (
              <NavLink
                key={to}
                to={to}
                end={to === "/"}
                className={({ isActive }) =>
                  [
                    "flex items-center gap-3 rounded-xl px-4 py-3 text-[15px] transition",
                    isActive
                      ? "bg-blue-600 text-white shadow-soft"
                      : "text-white/80 hover:bg-white/10 hover:text-white",
                  ].join(" ")
                }
              >
                <Icon className="text-xl" />
                <span>{label}</span>
              </NavLink>
            ))}
          </div>
        </nav>

        <div className="border-t border-white/10 p-5 dark:border-slate-800/80">
          <div className="rounded-2xl bg-white/10 p-4">
            <div className="font-semibold">{user?.name || "No user found"}</div>
            <div className="text-sm text-white/70">
              {displayRole || "No role found"}
            </div>

            <div className="mt-3 flex items-center gap-2 text-sm text-emerald-300">
              <span className="h-2 w-2 rounded-full bg-emerald-400" />
              Online
            </div>
          </div>

          <button
            onClick={() => setShowLogoutModal(true)}
            className="mt-4 flex w-full items-center gap-3 rounded-xl px-4 py-3 text-white/80 transition hover:bg-red-500/20 hover:text-white"
          >
            <FiLogOut className="text-xl" />
            <span>Log Out</span>
          </button>
        </div>
      </aside>

      {showLogoutModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="w-[380px] rounded-2xl bg-white p-6 shadow-2xl dark:bg-slate-900">
            <h2 className="text-xl font-semibold text-gray-800 dark:text-slate-100">
              Confirm Logout
            </h2>
            <p className="mt-2 text-sm text-gray-500 dark:text-slate-400">
              Are you sure you want to logout from your account?
            </p>

            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={() => setShowLogoutModal(false)}
                className="rounded-lg px-4 py-2 text-gray-600 transition hover:bg-gray-100 dark:text-slate-300 dark:hover:bg-slate-800"
              >
                Cancel
              </button>

              <button
                onClick={handleLogout}
                className="rounded-lg bg-red-500 px-4 py-2 text-white transition hover:bg-red-600"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}